/* eslint-disable react-hooks/exhaustive-deps */
import React, { useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'antd';
import ListStaff from './ListStaff';
import { useSelector } from 'react-redux';
import { getCurrentUser } from '@vantiva-sa/homesight_humaui/Store/authStore';
import { Actions } from '@vantiva-sa/homesight_humaui/Utilities/Constants';
import { DashboardIcon } from '../Common/Icons';
import Schedule from '../Schedule/Schedule';
import StaffForm from './StaffForm';
import useStaffList from '../Hooks/useStaffList';
import { getStaffList } from '@vantiva-sa/homesight_humaui/Store/dataStore';
import { objectSort } from '@vantiva-sa/homesight_humaui/Utilities/CommonUtilities';
import { translator } from '@vantiva-sa/homesight_humaui/Store/configStore';

const Staff = ({ parentBread }) => {
  const trans = useSelector(translator);
  const currentUser = useSelector(getCurrentUser);
  const useruuid = useMemo(() => currentUser.useruuid, [currentUser]);
  const { isFetching: fetchingStaffList, refetch: fetchStaff } = useStaffList({ useruuid });
  const staffList = useSelector(getStaffList(useruuid));

  const staffOrderedList = useMemo(() => {
    return [...staffList].sort(objectSort('firstname'));
  }, [staffList]);
  const [action, setAction] = useState(null);
  const [record, setRecord] = useState(null);
  const [modalVisible, setModalVisible] = useState(false);

  const onActionClick =
    (action, record, refresh = false) =>
    () => {
      setAction(action);
      setRecord(record);

      // Show modal for staff form actions
      if (action === Actions.addStaff || action === Actions.editStaff) {
        setModalVisible(true);
      }

      refresh && fetchStaff();
    };

  const handleModalClose = () => {
    setModalVisible(false);
    setAction(null);
    setRecord(null);
  };

  const handleStaffFormAction =
    (action, record, refresh = false) =>
    () => {
      if (refresh) {
        fetchStaff();
      }
      handleModalClose();
    };

  const header = (parentBread || []).concat({
    label: trans('DASHBOARD'),
    icon: <DashboardIcon />,
    onClick: onActionClick(null, null),
  });

  return (
    <>
      {/* Show ListStaff unless Schedule is active */}
      {action !== Actions.addEvent && (
        <ListStaff
          parentBread={header}
          staffList={staffOrderedList}
          fetchingStaffList={fetchingStaffList}
          onActionClick={onActionClick}
        />
      )}
      {/* Show Schedule component if action is addEvent */}
      {action === Actions.addEvent && (
        <Schedule
          activeKey={null}
          contactOrStaffAction={true} //staff action callback check
          action={action}
          hubRecord={record}
          parentBread={header}
          userHubCall={true}
          onActionClick={onActionClick}
        />
      )}
      {/* Modal for Staff Form */}
      <Modal
        title={''}
        open={modalVisible}
        onCancel={handleModalClose}
        footer={null}
        width={'fitContent'}
        centered
        destroyOnClose
        className="staff-form-modal"
        closable={false}
      >
        {(action === Actions.addStaff || action === Actions.editStaff) && (
          <StaffForm
            record={record}
            action={action}
            parentBread={[]} // Empty breadcrumb since it's in modal
            onActionClick={handleStaffFormAction}
            staffList={staffOrderedList}
            isModal={true} // Pass a prop to indicate it's in modal
            currentUser={currentUser}
            handleModalClose={handleModalClose}
          />
        )}
      </Modal>
    </>
  );
};

Staff.propTypes = {
  parentBread: PropTypes.arrayOf(PropTypes.object),
};

export default Staff;
